module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/Rooms_03_zerowastefacilities_02.png";